import { api } from 'utility';
import {
  getSubscriptionPlanUrl,
  getCreditUrl,
  getProductSearchUrl,
  getGuildServiceUrl,
  getAllBusinessInfoUrl,
  getDetaileSubscriptionPlanUrl,
} from 'URLs';
// Cards
export function getSubscription(id) {
  return api
    .get(getDetaileSubscriptionPlanUrl(id), { params: { offset: 0, size: 10 } })
    .then((res) => res.data);
}

export function postSubscription(data) {
  return api.post(getSubscriptionPlanUrl(), data).then((res) => res.data);
}
export function putSubscription(data) {
  return api.put(getSubscriptionPlanUrl(), data).then((res) => res.data);
}

export function getCreditAccounts(obj) {
  const params = { ...obj };
  return api.get(getCreditUrl(), { params }).then((res) => res.data);
}

export function getProducts(params) {
  return api.get(getProductSearchUrl(), { params }).then((res) => res.data);
}

export function getGuildsList(obj) {
  const params = { ...obj };
  return api.get(getGuildServiceUrl(), { params }).then((res) => res.data);
}

export function getBusinessList(obj) {
  const params = { offset: 0, size: 10, ...obj };
  return api.get(getAllBusinessInfoUrl(), { params }).then((res) => res.data);
}

export default {
  getSubscription,
  postSubscription,
  putSubscription,
  getCreditAccounts,
  getProducts,
  getGuildsList,
  getBusinessList,
};
